import React from "react";
import { Grid } from "@mui/material";
import Layout from "../Layout";
import ProfileFormDetails from "../../../widgets/management/operator-details/ProfileFormDetails";
import OperatorTable from "../../../widgets/supervisor/operator-details/OperatorTable";
import ProfileBanner from "../../../widgets/management/operator-details/ProfileBanner";
import { useNavigate } from "react-router-dom";

function OperatorDetails(props) {
  const navigate = useNavigate();

  const refreshList = () => {
    // Здесь логика обновления данных, например, перезагрузка таблицы
    console.log("Обновление списка после удаления");
  };
  return (
    <Layout>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        {/* <Prifuke */}
        <ProfileBanner
          onDeleted={refreshList}
          redirectPath="/management/operators"
        />
      </Grid>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <ProfileFormDetails />
      </Grid>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        <OperatorTable />
      </Grid>
      <Grid sx={{ mb: 2 }} size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 7 }}>
        {/* Тимчасово приховано за ТЗ */}
        {/* <Box sx={{ display: "flex", gap: 2 }}>
          <AvailableCRMOperator />
          <FunctionalityOperator />
        </Box> */}
      </Grid>
    </Layout>
  );
}

export default OperatorDetails;
